export const TRANSPORT_ORDER_KEYS = {
    TRANSPORT_ORDER_NUMBER: 'transportOrderNumber',
    TOUR_NUMBER: 'tourNumber',
    TRUCK_LICENSE_PLATE: 'truckLicensePlate',
    DRIVE_INSTRUCTIONS: 'drive_instruction', //This might be from a diff endpoint
    TRANSPORT_MODE: 'transportMode',
    PLANNED_VOLUME_PALLED_SPACES: 'plannedVolumePalletSpaces',
    WEIGHT: 'weight',
    TRAILER_LICENSE_PLATE: 'trailerLicensePlate',
    TRAILER2_LICENSE_PLATE: 'trailer2LicensePlate',
    TEMPERATURE_ZONE: 'temperatureZone',
    TRAFFIC_TYPE: 'trafficType',
    STATUS: 'status',
    PRIORITY_SERVICE: 'priorityService',
    PICKUP_LOCATIONS_SUM: 'pickupLocationsSum',
    DELIVERY_LOCATIONS_SUM: 'deliveryLocationsSum',
    NUMBER_OF_TOUR_STOPS: 'numberOfTourStops'
};